export function formatCpf(value) {
  const onlyNumbers = value.replace(/\D/g, '')

  const limitedNumbers = onlyNumbers.slice(0, 11)

  return limitedNumbers
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}
